import { PropsWithChildren } from 'react';
import { classNameList } from 'utils/property';
import styles from './Tooltip.module.scss';

interface IProps {
  show?: boolean;
  position?: 'top' | 'bottom';  // default to bottom
  tip?: 'left' | 'middle' | 'right';  // default to right
  onClick?: () => void;
}

export const Tooltip = ({ show, children, position, tip, onClick }: PropsWithChildren<IProps>) => {
  show ??= true;
  position ??= 'bottom';
  tip ??= 'right';
  
  return (
    <div
      tabIndex={0}
      role="tooltip"
      onClick={onClick ?? (() => {})}
      onKeyDown={onClick 
        ? (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            onClick();
          }
        }
        : () => {}}
      className={classNameList(styles.tooltip,
      show ? styles.show : null,
      position === 'top' ? styles.top : styles.bottom,
      tip === 'left' && styles.tipLeft,
      tip === 'right' && styles.tipRight,
      tip === 'middle' && styles.tipMiddle)}>
      {children}
    </div> 
  );
};